import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Contracts = lazy(() => import(`Pages/Screens/Office/Contracts/Societario`));
const Distratos = lazy(() => import(`Pages/Screens/Office/Contracts/Distrato`));
const NewContract = lazy(() => import(`Pages/Screens/Office/Contracts/NewPage`));
const Assistant = lazy(() => import(`Pages/Screens/Office/Contracts/Assistant`));

const ContractsRoutes: RouteObject[]= [
    {
        path: 'contracts',
        children: [
            { path: "societario", element: <LoadComponent component={Contracts} /> },
            { path: "distrato", element: <LoadComponent component={Distratos} /> },
            { path: "new", element: <LoadComponent component={NewContract} /> },
            { path: "assistant", element: <LoadComponent component={Assistant} /> },
        ],
    }
]

export default ContractsRoutes;